export default "__VITE_ASSET__w1OUWLc9__"